export const CoreMonthlyPlanID = 'core-monthly';
export const CoreYearlyPlanID = 'core-yearly';
export const CorePlanIDs = [
  CoreMonthlyPlanID,
  CoreYearlyPlanID,
  'core-monthly-b2c',
  'core-yearly-b2c',
  'core-monthly-consumer',
  'core-yearly-consumer',
] as const;

export type CorePlanID = (typeof CorePlanIDs)[number];

export default (planID?: string | null): planID is CorePlanID => {
  if (!planID) {
    return false;
  }

  return CorePlanIDs.includes(planID as CorePlanID);
};
